/* ============================================================
   Header-Cart-Badge: zeigt die Artikelanzahl und aktualisiert
   sich sofort nach jedem Add-to-Cart (ohne Reload).
   Quellen: ajaxProduct:added / cart:updated / cart:refresh / cart:build
   + Wrap von window.SLIDECART_UPDATED (Slide-Cart-App).
   ============================================================ */
(function () {
  'use strict';

  function setBadge(count) {
    var bubbles = document.querySelectorAll('.cart-link__bubble');
    bubbles.forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0);
      var num = b.querySelector('.cart-link__bubble-num');
      if (num) num.textContent = count > 0 ? count : '';
    });
  }

  var pending = null;
  function refresh() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && typeof cart.item_count === 'number') setBadge(cart.item_count); })
        .catch(function () {});
    }, 250);
  }

  ['ajaxProduct:added', 'cart:updated', 'cart:refresh', 'cart:build'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });

  // Slide-Cart-App liefert den Cart direkt – wrappen statt überschreiben
  function wrapSlideCart() {
    var prev = window.SLIDECART_UPDATED;
    window.SLIDECART_UPDATED = function (cart) {
      if (typeof prev === 'function') { try { prev(cart); } catch (e) {} }
      if (cart && typeof cart.item_count === 'number') setBadge(cart.item_count);
    };
  }
  if (typeof window.SLIDECART_UPDATED === 'function') wrapSlideCart();
  else {
    // sl-custom.js definiert die Funktion evtl. später
    var tries = 0;
    (function wait() {
      if (typeof window.SLIDECART_UPDATED === 'function') return wrapSlideCart();
      if (tries++ < 40) setTimeout(wait, 250);
      else wrapSlideCart();
    })();
  }
})();
